import { useState, useEffect } from 'react'

const useScript = (url: string) => {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const script = document.createElement('script')
    script.src = url
    script.async = true
    script.defer = true

    script.onload = () => {
      setReady(true)
    }

    script.onerror = () => {
      setReady(false)
      console.error('Script loading error')
    }

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [url])

  return ready
}

export default useScript
